import React from 'react';
import { Alert, Col, Form, Icon, Input, message, Modal, Row, Switch, Upload } from 'antd';
import axios from 'axios';
import debounce from 'debounce';

import { API_ENDPOINT } from '../../index';
import { _editBrand } from './actions';

import './index.css';

const defaultState = {
    validateStatus: 'success',
    inputMsg: ''
}
class EditBrandModal extends React.Component {
    render() {
        const { getFieldDecorator } = this.props.form;

        const { isEditModalOpen } = this.props;

        const {
            brand,
            loading,
            inputMsg,
            validateStatus,
        } = this.state;

        let { name, featured, image } = this.state.updatedBrand || false;

        // }
        return(
            <Modal
				title={`Edit brand:  ${brand.name}`}
				okText={"Save"}
				confirmLoading={loading}
				onOk={this.handleOnClickOK}
				onCancel={this.handleOnCancel}
				visible={isEditModalOpen}>
				
				{
					isEditModalOpen?
					[
						
		
						<Form>
							
							<Form.Item
								hasFeedback
								validateStatus={validateStatus}
								help={inputMsg}
								label="Brand Names">
		
								{getFieldDecorator('brand', {
									rules: [
										{validator: this.checkIfBrandAlreadyExist }
                                    ],
                                    initialValue: name
								})(
									<Input 
										placeholder="3M"/>
								)}
		
							</Form.Item>

                            <Form.Item
                                hasFeedback
                                label="Featured"
                                >

                                <div className="featured-switch">
                                    <Switch 
                                        onChange={this.togglefeatured}
                                        checked={featured}/>
                                </div>
                                

                            </Form.Item>

                            <Form.Item>
                                <div className="dropbox">
                                    <Alert
                                        message="Instructions to Upload Brand Image"
                                        description="File must be less than 2MB"
                                        type="info"
                                        showIcon
                                        />
                                    
                                    <Row type="flex" justify="center"
                                        style={{border: '1px solid ', borderColor: '#e8e8e8'}}>
                                        
                                        <Col className="image-container">
                                            {
                                                image ? 
                                                <img className="uploaded-image" 
                                                    src={image.url}
                                                    alt=""
                                                    />
                                                :
                                                ''
                                            }
                                        </Col>
                                    </Row>

                                    <Upload.Dragger 
                                        action={`${API_ENDPOINT}/api/upload/brand-image`}
                                        name='picture'
                                        accept="image/*"
                                        onChange={this.handleChange}
                                        withCredentials={true}
                                        beforeUpload={this.beforeUpload}
                                        >

                                    <Row>
                                        <p className="a fnt-upload-drag-icon">
                                        <Icon type="inbox" />
                                        </p>
                                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                        <p className="ant-upload-hint">Uploaded image will replace existing image</p>
                                    </Row>

                                        
                                    </Upload.Dragger>
                                </div>
                            </Form.Item>
						</Form>
		
						
						// this.state.searchedBrands.map(
						// 	(_brand, i) => <p key={i}>{_brand.name}</p>
						// )
					]:
					null
				}

			</Modal>
        )
    }

    state = {
        ...defaultState,
        brand: false,
        brands: [],
        existingBrandName: false,
        loading: false,
        updatedBrand: {
            name: false,
            featured: false,
            _id: false,
            image:false
        },
        
    }

    constructor(props) {
        super(props);

        this.checkCurrentBrands = debounce(this.checkCurrentBrands, 350)
    }
    componentWillMount() {
        const { brand } = this.props;
        this.setState({
            brand: brand || false,
            existingBrandName: brand.name,
            updatedBrand: {
                featured: brand.featured || false,
                name: brand.name,
                image: brand.image,
                _id: brand._id
            }
        })


    }

    beforeUpload(file) {

        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          message.error('Image must smaller than 2MB!');
        }
        return isLt2M;
    }

    checkIfBrandAlreadyExist = (rule, value, callback) => {
        // console.log(rule, value, callback)
        const { existingBrandName } = this.state;

        // console.log(existingBrandName)
        if(value === existingBrandName) {
            this.showSuccess(2)
        } else {
            if(value) {
                // const { brands } = this.state;
                
                if(this.checkCurrentBrands(value, callback)) {
                    console.log("ERROR")
                } else {
                    this.setState({
                        inputMsg: 'Checking the database if brands already exist...'
                    })
                }
            }
        }

        
    }

    checkCurrentBrands = (brand, cb) => {
        
        axios({
            withCredentials: true,
            url: `${API_ENDPOINT}/api/brands/search/${brand.trim()}`
        })
            .then( res => {
                
                // const { brands } = this.state;
                console.log(brand.trim().toLowerCase());

                this.setState({
                    searchedBrands: res.data.brands
                })

                // console.log(brands, brand);

                // if (this.checkCurrentBrands(brands, brand)){
                // 	this.showError(4);

                // 	cb("This brand already exist! Please do not add the same brands twice!");
                // } else
                if(
                    res.data.brands.filter( _brand => {
                        return _brand.lowerCaseName === brand.trim().toLowerCase() 
                    }).length > 0
                ){

                    this.showError(5);
                    cb("This brand already exist! Please do not add the same brands twice!");

                } else {

                    this.showSuccess();
                    this.setState({
                        updatedBrand: {
                            ...this.state.updatedBrand,
                            name: brand.trim()
                        }
                    })
                    cb();

                }
            })
    }

    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }
    
    handleChange = (info) => {
        if (info.file.status === 'done') {
            this.getBase64(info.file.originFileObj, data => this.setState({ 
                 updatedBrand: {
                    ...this.state.updatedBrand,
                    image: info.file.response.brandImage
                    }
                })
            );
        }
    } 

    handleOnCancel = () => {
        this.props.onCloseModal()
    }


    handleOnClickOK = () => {
        this.setState({
            loading: true
        })
        let { 
            brand,
            updatedBrand,
            validateStatus 
        } = this.state;

        const { _id } = brand;

        let updatedName = this.props.form.getFieldValue('brand');
        if( validateStatus === "success" ) {
            this.setState({
                updatedBrand: {
                    ...this.state.updatedBrand,
                    name: updatedName
                },
            })

            

            setTimeout(() => {
                _editBrand(_id, updatedBrand)
            },100)
            setTimeout(() => {
                this.setState({
                    loading: false
                })
                this.handleOnCancel()
            },1000)
            
        } else {
            message.error("Failed to send")
            this.setState({
                loading: false
            })
        }
        /***** VALIDATE FIELDS TAKEN OUT
        this.props.form.validateFields(
            (err, val) => {
                console.log(err, val)
                const { featured } = val || false;
              if (!err) {
                console.log(val)
                console.log("BRAND STATE " , this.state.brand)
                const { _id } = this.state.brand;
                this.setState({
                    updatedDetails: {
                        name: val.brand,
                        featured,
                    }
                })

                setTimeout(() => {
                    console.log(this.state)
                },300)

                }
            }
        );

        VALIDATE FIELDS TAKEN OUT */
    }

    normFile = (e) => {
        console.log('Upload event:', e);
        if (Array.isArray(e)) {
          return e;
        }
        return e && e.fileList;
      }

      

    showError = (int) => {
		this.setState({
			validateStatus: 'error',
			inputMsg: 'This brand already exist! Please do not add the same brands twice!'
		});
	}

    showSuccess = () => {
		this.setState({
			validateStatus: 'success',
			inputMsg: 'Valid'
		});
    }
    
    togglefeatured = () => {
        this.setState({
            updatedBrand: {
                ...this.state.updatedBrand,
                featured: !this.state.updatedBrand.featured 
            }
        })

        setTimeout(() => {console.log(this.state)} , 200)
    }
}

export default Form.create()(EditBrandModal);


// WEBPACK FOOTER //
// ./src/components/brands/edit-brand-modal.js